import { InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';

export const CurrencyTextFieldAdapter = ({
  input: { name, onChange, value, ...restInput },
  meta,
  ...rest
}: any) => {
  const [_value, _setValue] = useState(value);

  const _onChange = (e) => {
    if (/^\d+(,\d{0,3})?$/.test(e.target.value)) {
      _setValue(e.target.value);
      onChange(e.target.value);
    }
  };

  return (
    <TextField
      {...rest}
      name={name}
      onChange={_onChange}
      helperText={meta.touched ? meta.error : ''}
      error={meta.error && meta.touched}
      value={_value}
      inputProps={restInput}
      InputProps={{
        startAdornment: <InputAdornment position="start">€</InputAdornment>
      }}
      fullWidth
    />
  );
};
